import React from 'react';
import { StyleSheet, View } from 'react-native';
import Animated, {
  interpolate,
  useAnimatedStyle,
} from 'react-native-reanimated';

import type { LoadMainVariantProps } from '../types';
import { useStaggeredWave } from '../loadMainMotion';

function Bar({
  width,
  max_height,
  color,
  duration_ms,
  index,
  count,
  is_rtl,
}: {
  width: number;
  max_height: number;
  color: string;
  duration_ms: number;
  index: number;
  count: number;
  is_rtl: boolean;
}) {
  const phase = useStaggeredWave(duration_ms, index, count, is_rtl);

  const bar_style = useAnimatedStyle(() => ({
    height: max_height * interpolate(phase.value, [0, 1], [0.28, 1]),
    opacity: interpolate(phase.value, [0, 1], [0.42, 1]),
    transform: [{ scaleY: interpolate(phase.value, [0, 1], [0.85, 1]) }],
  }));

  return (
    <Animated.View
      style={[
        {
          width,
          borderRadius: width,
          backgroundColor: color,
        },
        bar_style,
      ]}
    />
  );
}

export function BarsLoader({ size, colors, duration_ms, is_rtl }: LoadMainVariantProps) {
  const bar_count = 5;
  const bar_width = Math.max(2.5, Math.round(size * 0.09));
  const bar_height = size * 0.88;
  const gap = Math.max(2.5, Math.round(size * 0.07));

  return (
    <View
      style={[
        styles.row,
        {
          width: size,
          height: size,
          gap,
          flexDirection: 'row',
        },
      ]}>
      {Array.from({ length: bar_count }, (_, index) => (
        <Bar
          key={index}
          width={bar_width}
          max_height={bar_height}
          color={index % 2 === 0 ? colors.primary : colors.secondary}
          duration_ms={duration_ms}
          index={index}
          count={bar_count}
          is_rtl={is_rtl}
        />
      ))}
    </View>
  );
}

const styles = StyleSheet.create({
  row: {
    alignItems: 'flex-end',
    justifyContent: 'center',
  },
});
